import styled from "styled-components";

export const Container = styled.div`
  padding: 0.3rem 2.8rem;

  @media (max-width: 632px) {
    padding: 0.3rem 1rem;
  }
  @media (max-width: 770px) {
    padding: 0.3rem 2rem;
  }
`;
